<template>
  <b-container fluid class="py-3">
    <b-row class="justify-content-center">
      <b-col cols="12" xl="10">
        <!-- Header -->
        <b-row class="align-items-center mb-3">
          <b-col cols="12" class="d-flex justify-content-between">
            <h2 class="mb-0 text-dark">{{ $t("dashboard.gameboard") }}</h2>
            <b-button class="rounded-pill px-3" variant="primary" to="/teams">
              <span style="font-size:14px">{{ $t("dashboard.add_to_gameboard") }}</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- Main -->
        <b-row>
          <!-- Left: Gameboard (centered & sticky on lg+) -->
          <b-col cols="12" lg="6" class="mb-4 mb-lg-0 d-flex justify-content-center sticky-lg">
            <b-card no-body class="board-card">
              <GameBoardV2 />
            </b-card>
          </b-col>

          <!-- Right: Leaderboards -->
          <b-col cols="12" lg="6">
            <DashboardLeaderboards />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import GameBoardV2 from "@/components/GameBoardV2/GameBoard.vue"
import DashboardLeaderboards from "@/components/Dashboard/DashboardLeaderboards.vue"
export default { components: { GameBoardV2, DashboardLeaderboards } }
</script>

<style scoped>
.text-dark { color: #1a1947; }

/* subtle frame around the board without affecting its maxWidth cap inside GameBoardV2 */
.board-card {
  width: 100%;
  border: 0;
  padding: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  border-radius: 12px;
  background: #fff;
}

/* keep the board visible while scrolling long leaderboards */
@media (min-width: 992px) {
  .sticky-lg { position: sticky; top: 16px; }
}
</style>
